<template>
    <!-- 对话框 -->
    <el-drawer title="查看详情" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="1000px">
        
        

        <div class="container">

            <div style="margin-bottom:15px">
                <el-row style="display:flex;">
                    <el-col>
                        <div>总提现金额:{{cash}}</div>    
                    </el-col>
                    <el-col>
                        <div>当前可提现金额:{{withdrawal}}</div>
                    </el-col>
                </el-row>
            </div>

            <template>

                <div class="handle-box-search">
                    

                    <div class="handle-box">

                        <el-row class="head-search">    
                        
                        <div
                                style="margin: 10px 0;display: flex;"
                                class="search-radio fs-big"
                        >

                            <div>
                                <div class="title">订单完成时间:</div>
                                
                                

                                <el-radio-group
                                        v-model="order_fixed_time_value"
                                        size="small"
                                        @change="orderFixedTimeChange"
                                >

                                <el-radio
                                            label=""
                                            border
                                    >
                                        全部
                                    </el-radio>

                                    <el-radio
                                            label="yesterday"
                                            border
                                    >昨天
                                    </el-radio>
                                    
                                    <el-radio
                                            label="between"
                                            border
                                    >自定义时间
                                    </el-radio>
                                </el-radio-group>

                            </div>

                                <el-date-picker
                                        v-if="order_fixed_time_value == 'between'"
                                        v-model="order_time_arrway"
                                        type="datetimerange"
                                        range-separator="-"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        @change="timeChange('order')"
                                >
                                </el-date-picker>

                        </div>
                        </el-row>

                    </div>

                    <el-button
                                type="primary"
                                icon="el-icon-search"
                                @click="searchBusinessRecord"
                                style="padding: 6px 12px;"
                        >搜索
                        </el-button>
                        

                    

                </div>

                <div class="tableScroll">
                    <el-table 
                            :data="tableData" 
                            class="table" 
                            ref="multipleTable" 
                            header-cell-class-name="table-header"
                            
                            
                >


                        <!-- <el-table-column type="index" label="序号">
                        </el-table-column> -->

                        <el-table-column prop="consumer_phone" label="扫码用户" min-width="120">
                        </el-table-column>

                        <el-table-column prop="order_time_stamp" label="订单完成时间" min-width="120">

                            <template slot-scope="scope">
                                {{scope.row.order_time_stamp == '0'?'':scope.row.order_time_stamp}}
                            </template>
                        </el-table-column>

                        <el-table-column label="订单金额" prop="order_amount" min-width="100">
                        </el-table-column>

                        

                        

                        <el-table-column label="商家分润金额" prop="money" min-width="100">
                        </el-table-column>


                        <el-table-column label="司机承担" prop="driver_bear" min-width="100">
                        </el-table-column>

                        <!-- 只要是有扫码下单时间，订单状态就是已完成 -->
                        <el-table-column
                            prop="status"
                            label="订单完成"
                        >
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.status=='1'?'success':'danger'">
                                    {{scope.row.order_time_stamp == '0'?'未完成':'已完成'}}
                                </el-tag>
                            </template>
                        </el-table-column>

                </el-table>

                <div class="pagination">

                     <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="pages_function"
                        :current-page="search_data_children.page"
                        :page-sizes="[10, 20, 30, 40 ,50]"
                        :page-size="search_data_children.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="result_data_children.count">
                    </el-pagination>

                </div>
                </div>

                

                  

                <!-- 分页组件 -->
                
                
                
            </template>
              <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
        </div>
    </el-drawer>
</template>

<script>

    var _this;
    export default {
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.search_data_children.business_code = _this.data;

                _this.businessRecord()

            },
        },
        data() {
            return {


                show: false,


                cash:'',
                withdrawal:'',

                //存放表格数据
                tableData: [],

                // 预约自定义时间
                order_time_arrway: [],

                order_fixed_time_value: '',


                search_time:'',

                
                //获取用户列表的数据
                search_data_children: {
                    //当前页数
                    page: 1,
                    //每页显示多少条数据
                    limit: 10,
                    business_code: '',
                    created_at: ''

                },
                result_data_children: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    } ,
                    
                }

                
                    
                

            };
        },
        created() {

            _this = this;
            // _this.businessRecord();

        },
        methods: {

            

            orderFixedTimeChange(val) {
                _this.order_time_arrway = [];

                _this.search_data_children.created_at = [];
                if (val == 'between') {
                   
                } else if (val == '') {
                } else {
                    _this.search_data_children.created_at.push(_this.order_fixed_time_value);

                    _this.search_data_children.created_at = JSON.stringify(_this.search_data_children.created_at);
                }
            },

           
            // 搜索时间选择触发
            timeChange(parm, val) {


                if(_this.order_time_arrway == null){
                    _this.search_data_children.created_at = []
                }else{
                    _this.search_data_children.created_at = JSON.stringify(['between'].concat(_this.order_time_arrway));
                }
                
                    
            },
                

            // 关闭方法
            closeDialog() {
                _this.show = false;
                
               
            },
            searchBusinessRecord(){

                _this.search_data_children.page = 1;

                _this.businessRecord();

            },

            businessRecord() {
                
                _this
                    .$post('/business/businessRecord', _this.search_data_children, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data.list;
                        _this.result_data_children = res;
                       
                       _this.withdrawal = res.data.total_amount.withdrawal;
                       _this.cash = res.data.total_amount.cash;


                    })
                    .catch((err) => {});
            },
            //页码值改变
            pages_function(search_data) {
                //赋值
                _this.search_data_children.page = search_data;

                console.log(_this.search_data_children.page);

                //初始化列表
                _this.businessRecord();
            },

            //下拉条（每页显示多少数据）变化
			handleSizeChange(val) {

                console.log(val);

				_this.search_data_children.limit = val;

                _this.businessRecord();

			},

            


        

           
        }

 };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }

    .tableScroll{
        max-height: 500px;
        overflow: hidden;
        overflow-y: auto;
    }
</style>